import type { BoardModelKind } from "./kind";
import { LOCATION_CHIP_DEBUG_PAD_PX } from "./geometry";
import type { Bounds } from "./bounds";

/** Cancel most chip pad; net halo ≈ 4px outside the chip rect (shadow). */
const LOCATION_CHIP_RING_INSET_PX = LOCATION_CHIP_DEBUG_PAD_PX - 4;

/**
 * Per-side adjustment to measured bounds (px). Negative expands outward (outer rings);
 * positive shrinks inward so nested kinds do not share one border edge.
 */
const RING_INSET_BY_KIND: Partial<Record<BoardModelKind, number>> = {
  Location: -12,
  LocationGroup: 2,
  LocationPrimary: LOCATION_CHIP_RING_INSET_PX,
  LocationSecondary: LOCATION_CHIP_RING_INSET_PX,
  CharacterGroup: 0,
  Character: 4,
  CharacterPortrait: 7,
  CharacterName: 7,
};

const MIN_DEBUG_FRAME_PX = 6;

export function insetDebugBounds(
  kind: BoardModelKind,
  box: Bounds,
): Bounds | null {
  const inset = RING_INSET_BY_KIND[kind] ?? 0;
  const next: Bounds = {
    minX: box.minX + inset,
    minY: box.minY + inset,
    maxX: box.maxX - inset,
    maxY: box.maxY - inset,
  };
  if (next.maxX - next.minX < MIN_DEBUG_FRAME_PX) {
    return null;
  }
  if (next.maxY - next.minY < MIN_DEBUG_FRAME_PX) {
    return null;
  }
  return next;
}
